export const REQUEST_PROFILE_TAB_CHATS_PRIVATE = 'private'

export const REQUEST_PROFILE_TAB_CHATS_PUBLIC = 'public'

export const REQUEST_PROFILE_TAB_CHATS_TITLE_KEY = {
  [REQUEST_PROFILE_TAB_CHATS_PRIVATE]:
    'RequestProfileTabChats.PrivateChatSubTabKey',
  [REQUEST_PROFILE_TAB_CHATS_PUBLIC]:
    'RequestProfileTabChats.PublicChatSubTabKey',
}

export const REQUEST_PROFILE_TAB_CHATS_SUB_TAB_QA_NAME = {
  [REQUEST_PROFILE_TAB_CHATS_PRIVATE]: 'requestProfileTabChatsSubTabPrivate',
  [REQUEST_PROFILE_TAB_CHATS_PUBLIC]: 'requestProfileTabChatsSubTabPublic',
}

// Sub-tab order follows the `reversed_request_chat_tabs` UK config flag:
// false → Public first (default), true → Private first.
export const REQUEST_PROFILE_TAB_CHATS_ORDER = [
  REQUEST_PROFILE_TAB_CHATS_PUBLIC,
  REQUEST_PROFILE_TAB_CHATS_PRIVATE,
]

export const REQUEST_PROFILE_TAB_CHATS_ORDER_REVERSED = [
  ...REQUEST_PROFILE_TAB_CHATS_ORDER,
].reverse()

// Sub-tabs row is shown only when the user is allowed to see all available
// chat sub-tabs — otherwise we render the single chat directly without tabs.
export const REQUEST_PROFILE_TAB_CHATS_SUB_TABS_VISIBLE_COUNT =
  REQUEST_PROFILE_TAB_CHATS_ORDER.length

export const REQUEST_PROFILE_TAB_CHATS_PERMISSION_KEY = {
  [REQUEST_PROFILE_TAB_CHATS_PRIVATE]: 'can_view_private_chat',
  [REQUEST_PROFILE_TAB_CHATS_PUBLIC]: 'can_view_public_chat',
}
